import Chart from 'chart'
import xaxis from './lib/x-axis'
import xScaler from './lib/x-scaler'
import hoverTooltipRows from './lib/hover-tooltip-rows'
import hoverContents from './lib/hover-contents'
import * as d3 from 'd3-selection'
import { dimensions as xDimensions } from 'chart/src/node_modules/x-axis'
import {timeParse} from 'd3-time-format'

const parse = timeParse('%Y-%m-%d')

const order = ['area', 'line']

export default function (el, data) {
  d3.select(el)
    .classed('initiative-chart', true)

  let chart = new Chart(el)
    , plot = data.plots[0]

  plot.breakdown = {
    range: [0, 1] // Fake a breakdown range, so the chart code doesn't think we're a no-breakdown style chart
  }
  plot.id = 0 // To make the x-scaler happy.
  plot.series = plot.series.map(function (s) {
    s.points = s.points.map(function (p) {
      p.title = p.title instanceof Date ? p.title : parse(p.title)
      return p
    })
    return s
  })

  plot.series.sort((a, b) => {
    return order.indexOf(a.type) - order.indexOf(b.type)
  })

  data.axes = data.axes || {}

  if (!(data.axes.bottom && data.axes.bottom.formatter)) {
    data.axes.bottom.formatter = function (d) { return d }
  }

  // See if there are data points on the right access
  let rightPoints = plot.series.filter(s => s.axis === 'right')
                               .map(s => s.points)[0]
                               .length
  if (!rightPoints) {
    let rightAxis = data.axes && data.axes.right || {}
    // If there aren't points on the y-axis, chart code won't show the right y-axis labels
    // So force the min/max to 0/1
    rightAxis.yMaxForce = 1
    rightAxis.yMinForce = 0

    data.axes.right = rightAxis
  }

  let yScaler = chart.yScaler()
  xaxis.dimensions = xDimensions  // Hack to set the dimensions from chart into this x-axis

  chart.xScaler(xScaler)
       .yScaler(function () {
         let scaler = yScaler.apply(this, arguments)
         scaler.nice(false)
         return scaler
       })
       .curve({
         area: null, // Removes the default area path tension
         line: null
       })
       .xaxis(xaxis)
       .xAccessor(d => d.title)
       .hoverTooltipRows(hoverTooltipRows)
       .hoverContents(hoverContents)
       .dimensions(function (dim) {
         dim.height -= 30
         return dim
       })

  chart.render(data)

  // Applies the series color for each y-axis
  // The chart module doesn't do this we are actually displaying three series in an initiative chart
  plot.series.filter(series => series.type === 'line')
             .forEach(series => {
               d3.select(el)
                 .select('.axis-y-' + series.axis)
                 .classed(series.color, true)
             })

  return chart
}
